class LoyaltyPerks extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['trigger', 'content']
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    if (this?.els?.trigger?.exists) {
      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const datasetId = event.target.closest(this.els.trigger.selector).dataset
      .index

    this.els.content.elements.forEach(contentEl => {
      contentEl.setAttribute(
        'data-mobile-hidden',
        contentEl.dataset.index !== datasetId,
      )
    })

    this.els.trigger.elements.forEach(triggerEl => {
      const isActive = triggerEl.dataset.index === datasetId
      triggerEl.setAttribute('aria-pressed', isActive)

      if (isActive) {
        triggerEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest',
        })
      }
    })
  }
}

if (!customElements.get('loyalty-perks')) {
  customElements.define('loyalty-perks', LoyaltyPerks)
}
